import { AxiosClient } from "./AxiosClient";

const isII = process.env.REACT_APP_IS_II;

const TARGET_TYPES = isII
  ? [{ key: "rpt_section1", default_title: "Horizon" }]
  : [
      { key: "company_profile", default_title: "Company Profile" },
      { key: "customers", default_title: "" },
      { key: "market_size", default_title: "" },
      { key: "products", default_title: "" },
      { key: "ip", default_title: "" },
      { key: "complaints", default_title: "" },
      { key: "financial", default_title: "" },
      { key: "trends", default_title: "" },
      { key: "partners", default_title: "" },
      { key: "executives", default_title: "" },
      { key: "employees", default_title: "" },
      { key: "location", default_title: "" },
      { key: "neightbors", default_title: "" },
      { key: "certs", default_title: "" },
    ];

export const getAvailableWikiData = async (target) => {
  try {
    const results = await Promise.allSettled([
      AxiosClient.post("wiki/getCompanyProfileIcon", { target }),
      AxiosClient.post("wiki/getCompanyEmployeesIcon", { target }),
      AxiosClient.post("wiki/getCourtCasesIcon", { target }),
      AxiosClient.post("wiki/getNeighborsIcon", { target }),
      AxiosClient.post("wiki/getGovAwardsIcon", { target }),
      AxiosClient.post("wiki/getDomainCertsIcon", { target }),
      AxiosClient.post("wiki/getBolsIcon", { target }),
      AxiosClient.post("wiki/getSanctionLookupIcon", { target }),
      AxiosClient.post("wiki/getCrypto", { target }),
      AxiosClient.post("wiki/getAvailableTargetTypes", { target }),
      AxiosClient.post("wiki/getDomainInfo", { target }),
      AxiosClient.post("wiki/getMld", { target }),
    ]);

    const getData = (index) => {
      const result = results[index];

      if (
        result.status === "fulfilled" &&
        result.value?.data &&
        result.value.data !== "fail"
      ) {
        return result.value.data;
      }

      return null;
    };

    const profile = getData(0);
    const employees = getData(1);
    const cases = getData(2);
    const neighbors = getData(3);
    const gov = getData(4);
    const domainsCerts = getData(5);
    const bols = getData(6);
    const sanctions = getData(7);
    const crypto = getData(8);
    const reportTypes = getData(9);
    const domainIPs = getData(10);
    const mld = getData(11);

    const response_array = [];

    response_array.push({
      sub_section: "Overview",
      ...(profile ? { data: profile } : {}),
    });

    if (employees && Array.isArray(employees) && employees.length > 0) {
      response_array.push({ sub_section: "Key Employees", data: employees });
    }

    if (cases && cases.count > 0) {
      response_array.push({ sub_section: "Court Cases", data: cases });
    }

    if (neighbors && Array.isArray(neighbors) && neighbors.length > 0) {
      response_array.push({ sub_section: "Neighbors", data: neighbors });
    }

    if (gov && gov.count > 0) {
      response_array.push({ sub_section: "Gov Awards", data: gov });
    }

    if (domainIPs && domainIPs.count > 0) {
      response_array.push({ sub_section: "domainIPs", data: domainIPs });
    }

    if (
      domainsCerts &&
      Array.isArray(domainsCerts) &&
      domainsCerts.length > 0
    ) {
      const transformedData = domainsCerts.map((item) => ({
        title: item.name_value,
        value: item.issuer_ca_id,
      }));

      response_array.push({ sub_section: "Domains", data: transformedData });
    }

    if (
      bols &&
      Array.isArray(bols) &&
      bols.length > 0 &&
      bols.find((item) => item.bol_count)?.bol_count > 0
    ) {
      response_array.push({ sub_section: "BOLs", data: bols });
    }

    if (sanctions && sanctions.count > 0) {
      response_array.push({ sub_section: "Sanctions", data: sanctions });
    }

    if (crypto && Array.isArray(crypto) && crypto.length > 0) {
      response_array.push({ sub_section: "Crypto", data: crypto });
    }

    if (reportTypes && Array.isArray(reportTypes) && reportTypes.length > 0) {
      response_array.push({
        sub_section: "Reports",
        data: { count: reportTypes.length },
      });
    }

    if (mld && Array.isArray(mld) && mld.length > 0) {
      response_array.push({
        sub_section: "MLD",
        data: { count: mld.length },
      });
    }

    return response_array;
  } catch (err) {
    console.error("Error fetching wiki data:", err);
    return [];
  }
};

export const getCompanyEmployees = async (target) => {
  try {
    return await AxiosClient.post("wiki/getCompanyEmployees", { target });
  } catch (error) {
    console.error("Error fetching company employees:", error);
    return { data: [] };
  }
};

export const getCourtCases = async (target) => {
  try {
    return await AxiosClient.post("wiki/getCourtCases", { target });
  } catch (error) {
    console.error("Error fetching company court cases:", error);
    return { data: [] };
  }
};

export const getNeighbors = async (target) => {
  try {
    return await AxiosClient.post("wiki/getNeighbors", { target });
  } catch (error) {
    console.error("Error fetching company getNeighbors:", error);
    return { data: [] };
  }
};

export const getDomainCerts = async (target) => {
  try {
    return await AxiosClient.post("wiki/getDomainCerts", { target });
  } catch (error) {
    console.error("Error fetching company getDomainCerts:", error);
    return { data: [] };
  }
};

export const getSanctions = async (target) => {
  try {
    return await AxiosClient.post("wiki/getSanctionLookup", { target });
  } catch (error) {
    console.error("Error fetching company getSanctions:", error);
    return { data: [] };
  }
};

export const getCrypto = async (target) => {
  try {
    return await AxiosClient.post("wiki/getCrypto", { target });
  } catch (error) {
    console.error("Error fetching company getCrypto:", error);
    return { data: [] };
  }
};

export const getDomainInfo = async (target) => {
  try {
    return await AxiosClient.post("wiki/getDomainInfo", { target });
  } catch (error) {
    console.error("Error fetching company getDomainInfo:", error);
    return { data: [] };
  }
};

export const getAvailableTargetTypes = async (target) => {
  try {
    return await AxiosClient.post("wiki/getAvailableTargetTypes", {
      target,
    });
  } catch (error) {
    console.error("Error fetching available target types:", error);
    return { data: [] };
  }
};

// Shape of one section item from reports/getUniversalReportSection:
// { window, window_label, section_title, target_type, timestamp,
//   document_id, content, sources: string[], screenshots: string[] (S3 URLs),
//   total_count,
//   product_images?: string[], product_title?: string[], product_risk?: string[]
//     (optional, index-aligned per product; see getReportProducts) }
const normalizeReportSection = (item) => {
  if (!item || typeof item !== "object") return null;
  return {
    ...item,
    sources: (item.sources || []).filter(
      (s) => typeof s === "string" && s.trim(),
    ),
    screenshots: (item.screenshots || []).filter(
      (s) => typeof s === "string" && s.trim(),
    ),
    total_count:
      typeof item.total_count === "number" ? item.total_count : null,
  };
};

export const getReportsII = async () => {
  try {
    const responses = await Promise.all(
      [1, 2, 3, 4, 5].map((i) =>
        AxiosClient.post("reports/getUniversalReportSection", {
          target_type: `rpt_section${i}`,
        })
      )
    );

    // The section payload arrives wrapped in a `msg` envelope
    // ({ msg: <section | section[]> }); unwrap it, tolerating a bare
    // payload, and normalize single object vs array-of-versions.
    const reports = responses
      .flatMap((response) => {
        const data = response?.data;
        const payload =
          data && typeof data === "object" && "msg" in data ? data.msg : data;
        return Array.isArray(payload) ? payload : payload ? [payload] : [];
      })
      .map(normalizeReportSection)
      .filter(Boolean);

    return { data: reports };
  } catch (error) {
    console.error("Error fetching II reports:", error);
    return { data: [] };
  }
};

export const getReports = async (target) => {
  if (!Array.isArray(TARGET_TYPES) || TARGET_TYPES.length === 0) {
    return { data: [] };
  }

  try {
    const reportPromises = TARGET_TYPES.map(({ key }) =>
      AxiosClient.post("wiki/getReports", { target_type: key, target }),
    );

    const results = await Promise.allSettled(reportPromises);

    const allReports = results.reduce((acc, result, index) => {
      const { key, default_title } = TARGET_TYPES[index];
      const versions = result.value?.data;
      if (
        result.status === "fulfilled" &&
        Array.isArray(versions) &&
        versions.length > 0 &&
        versions[0].content != null
      ) {
        acc.push({
          ...versions[0],
          target_type: key,
          title: versions[0].section_title || default_title,
          versions,
        });
      }

      return acc;
    }, []);

    return { data: allReports };
  } catch (error) {
    console.error("Error fetching reports:", error);
    return { data: [] };
  }
};

export const getBols = async (target) => {
  try {
    return await AxiosClient.post("wiki/getBols", { target });
  } catch (error) {
    console.error("Error fetching company getBols:", error);
    return { data: [] };
  }
};

export const getMld = async (target) => {
  try {
    return await AxiosClient.post("wiki/getMld", { target });
  } catch (error) {
    console.error("Error fetching company getMld:", error);
    return { data: [] };
  }
};
